import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import './HeaderStyle.css';
import * as actions from '../actions';

class Header extends Component {
  renderLinks = () => {
    if (this.props.authenticated) {
      return (
        <div className="flex-container">
          <div className="flex-container" style={{
            alignItems: 'center',
            justifyContent: 'space-around',
            flexDirection: 'column',
            marginRight: '15px' }}>
            <div>
              {this.props.email}
            </div>
            <button className='signout-button'
              onClick={ async () => {
                await this.props.signout();
                this.props.history.push('/signin');
              }}
            >
              Sign Out
            </button>
          </div>
        </div>
      );
    } else {
      return (
        <div className="flex-container">
        </div>
      );
    }
  }

  render() {
    return (
      <div className="headerr">
        <div className="header">
          <div className="logo flex-container">
            <a href="https://www.eaterpad.com"><img src={require('../assets/logo.png')} height="40"/></a>
          </div>
          {this.renderLinks()}
        </div>
      </div>
    );
  }
}

function mapStatetoProps(state) {
  return {
    authenticated: state.auth.authenticated,
    user_email: state.auth.user_email,
    email: state.user.user_personal_details.email
  };
}

export default connect(mapStatetoProps, actions)(Header);
